<template>
  <header class="header-global">
    <base-nav class="navbar-main position-fixed bg-white z-20" transparent type="" effect="" expand>
      <ul class="navbar-nav  align-items-center  ">
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="#">
            TOP
          </a>
        </li>
      </ul>
      <ul class="navbar-nav  align-items-center ml-lg-auto ">
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="javascript:void(0)" v-on:click='clickAnchor("gallery")'>
            GALLERY
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="javascript:void(0)" v-on:click='clickAnchor("design")'>
            DESIGN
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="javascript:void(0)" v-on:click='clickAnchor("about_us")'>
            ABOUT
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="javascript:void(0)" v-on:click='clickAnchor("faq")'>
            FAQ
          </a>
        </li>


        <li v-if="youtube_url.length > 0" class="nav-item">
          <a :href="youtube_url" target="_blank" class="nav-link nav-link-icon">
            <i class="fa fa-youtube-play fa-2x" aria-hidden="true"></i>
          </a>
        </li>

        <li v-if="instagram_url.length > 0" class="nav-item">
          <a :href="instagram_url" target="_blank" class="nav-link nav-link-icon">
            <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
          </a>
        </li>

        <li v-if="whatsapp_url.length > 0" class="nav-item">
          <a :href="whatsapp_url" target="_blank" class="nav-link nav-link-icon">
            <i class="fa fa-whatsapp fa-2x" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  },
  data() {
    return {
      isHomePage: true,
      youtube_url: 'https://www.youtube.com/watch?v=CE_ellIh8Ng&ab_channel=Snapture',
      instagram_url: 'https://www.instagram.com/snapture.io',
      whatsapp_url: 'https://wa.me/91045836',
    }
  },
  created() {
    this.isHomePage = this.$route.path === '/';
  },
  methods: {
    clickAnchor(target) {
      const element = document.getElementById(target);
      if (this.isHomePage) {
        element.scrollIntoView({behavior: 'smooth'});
      } else {
        this.$router.push({path: '/', hash: target},);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.nav-link {
  font-size: 14px;
}

.z-20 {
  z-index: 20;
}

</style>
